import React from "react"
import PropTypes from "prop-types"
import {each, get} from "lodash"
import {Row, Col} from "react-bootstrap"
import styled from "styled-components"

import {connect} from "@irati/store/connect"
import {RouterLink} from "@irati/ui/src/Link"
import {greys} from "@irati/ui/src/global/colors"
import id from "@irati/utils/id"
import {FormattedMessage} from "@irati/utils/lang"
import authentication from "@irati/auth"
import {MAX_RESULTS_PER_SECTION} from "../../../constants/search"

import EmptyState from "./EmptyState"
import SearchBarResults from "./Results"

const ViewAllLink = styled(RouterLink)`
  ${(props) =>
    props.isMobile &&
    `
      text-align: center !important;
      width: 100%;
   `}
  float: left !important;
`

const ResultTally = styled.div`
  font-size: 12px;
  color: ${greys.mediumDark};
  margin-bottom: 45px;
  float: right !important;
  ${(props) => (props.isMobile ? "text-align: center; width: 100%;" : "")}
`

const _transformDataToArray = (data) => {
  const results = []
  let count = 0

  each(data, (value, key) => {
    if (key !== "total") {
      count += value.length > MAX_RESULTS_PER_SECTION ? MAX_RESULTS_PER_SECTION : value.length
      results.push({
        data: value,
        title: key
      })
    }
  })

  return {results, count}
}

const ResultsState = (props, {apps}) => {
  /** Receive the normal results and transform them to how this component wants to use them */
  const {searchTerm, onItemSelect, onViewAllClick} = props

  const {results, count} = _transformDataToArray(props.results)

  const idNamespace = id("results-state", props)
  const idLinkViewAll = id("link-view-all", idNamespace)
  const isMobile = props.mq.lessThan.medium
  const isTablet = props.mq.lessThan.lg
  const total = get(props, "results.total", 0)
  const isGeoLocationEnabled = authentication.apps("platform.geoLocation")

  return (
    <div id={idNamespace}>
      <Row>
        {!total && <EmptyState id={idNamespace} onHide={onItemSelect} />}

        {total >= 1 && <SearchBarResults id={idNamespace} onClick={onItemSelect} results={results} searchTerm={searchTerm} />}
      </Row>
      <Row>
        {count < total && (
          <Col md={isGeoLocationEnabled && !isTablet ? 6 : 12}>
            <ViewAllLink
              id={idLinkViewAll}
              to={`/search/perks?q=${searchTerm}`}
              app={apps.PLATFORM}
              isMobile={isMobile}
              onClick={onViewAllClick}>
              <FormattedMessage id="perks.components.searchPopup.showAllResults" />
            </ViewAllLink>
            <ResultTally id={id("tally", idNamespace)} isMobile={isMobile}>
              <FormattedMessage
                id="perks.components.searchPopup.tallyResults"
                values={{
                  count,
                  total
                }} />
            </ResultTally>
          </Col>
        )}
      </Row>
    </div>
  )
}

ResultsState.propTypes = {
  results: PropTypes.object.isRequired,
  searchTerm: PropTypes.string.isRequired,
  onItemSelect: PropTypes.func.isRequired,
  mq: PropTypes.object.isRequired,
  onViewAllClick: PropTypes.func
}

ResultsState.defaultProps = {
  onViewAllClick: () => {}
}

ResultsState.contextTypes = {
  apps: PropTypes.object.isRequired
}

export const mapStateToProps = ({mq}) => ({mq})

export default connect(mapStateToProps)(ResultsState)
